import { getAllAttainmentLevelUrl } from "../config/Config";
import { getRequest, postRequest } from "./ServiceHelper";

export class AttainmentLevelService {
  static getAll = () => {
    return getRequest(getAllAttainmentLevelUrl());
  };

  static saveAttainmentLevels = (listOfDegrees) => {
    return postRequest(getAllAttainmentLevelUrl(), listOfDegrees);
  };
}
